// extracted by mini-css-extract-plugin
export var centerText = "_7g-8";
export var container = "_7g-0";
export var doughnutContainer = "_7g-7";
export var legend = "_7g-a";
export var legendItemColorDisplay = "_7g-b";
export var legendItemLabel = "_7g-d";
export var legendItemValue = "_7g-c";
export var lg = "_7g-5";
export var maxWidth = "_7g-9";
export var md = "_7g-4";
export var responsive = "_7g-6";
export var sm = "_7g-3";
export var xs = "_7g-2";
export var xxs = "_7g-1";